import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import {
  Button,
  Chip,
  Collapse,
  Divider,
  Drawer,
  FormControlLabel,
  Radio,
  RadioGroup,
  Slider,
  TextField,
  Switch,
  Paper,
  Typography,
  Grid
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {

  KeyboardDatePicker,
} from '@material-ui/pickers';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  papercontent: {
      marginTop : theme.spacing(2),
      textAlign : 'center'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  descriptionfield: {
    width: '100%'
   
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(2, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {
   
    padding: theme.spacing(1, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  radioGroup: {},
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  }
}));

const Addanswers = props => {
  const { open, onClose,selectedanswer, onSave,usercontent,masters,languages, viewtype, className, ...rest } = props;

  const classes = useStyles();
  const [value, setValue] = useState('');

  const initialValues = {
    is_comment : false,
    is_answer : false,
    sortorder : 1
  };

  const [expandProject, setExpandProject] = useState(true);
  const [expandCustomer, setExpandCustomer] = useState(false);
  const [values, setValues] = useState({ ...initialValues });

  const handleClear = () => {
    setValues({ ...initialValues });
  };

  const handleFieldChange = (event, field, value) => {
    event.persist && event.persist();
    setValues(values => ({
      ...values,
      [field]: value
    }));
  };
  const handleinputchange = type => e => {
    setValues({
      ...values,
      [type]: e.target.value
    });
  }
  const handleswitchchange = type => e => {
    setValues({
      ...values,
      [type]: e.target.checked
    });
  }
  const handleTagAdd = () => {
    setValues(values => {
      const newValues = { ...values };

      if (newValues.tag && !newValues.tags.includes(newValues.tag)) {
        newValues.tags = [...newValues.tags];
        newValues.tags.push(newValues.tag);
      }

      newValues.tag = '';

      return newValues;
    });
  };

  const handleTagDelete = tag => {
    setValues(values => {
      const newValues = { ...values };

      newValues.tags = newValues.tags.filter(t => t !== tag);

      return newValues;
    });
  };
  
  const handleToggleProject = () => {
    setExpandProject(expandProject => !expandProject);
  };

  const handleToggleCustomer = () => {
    setExpandCustomer(expandCustomer => !expandCustomer);
  };
  const handleoptionchange = type => (event, value) => {
   
    setValues(values => ({
      ...values,
      [type]: value
    }));
  }
  const handleSubmit = event => {
    event.preventDefault();
    // alert(JSON.stringify(values))
    onSave && onSave(values);
  };
  React.useEffect(() => {
    if(usercontent)
    {
      setValues({
        ...usercontent
        
      })

    }
 }, [usercontent]);
  const paymentStatusOptions = ['Pending', 'Canceled', 'Completed', 'Rejected'];
  const customerAgeOption = ['18 - 30', '30 - 45', '50 - 60', '60+'];
  const handleChange = (event) => {
    if(event.target.value == 'All')
    {
      if(event.target.checked)
      {
        setValues(values => ({
          ...values,
          ['languages']: ['All','Tamil','English','Telugu']
        }));
      }else{
        setValues(values => ({
          ...values,
          ['languages']: []
        }));
      }
    }else{
      if(event.target.checked)
      {
        var array = [...values.languages]
        if(array.length === 2)
        {
          array.push('All')
        }
        array.push(event.target.value)
        setValues(values => ({
          ...values,
          ['languages']: array
        }));
      }else{
        var array = [...values.languages]; // make a separate copy of the array
         if(array.length > 1)
         {
          var allindex = array.indexOf('All')
          if(allindex !== -1)
          {
            array.splice(allindex, 1)
          }

          var index = array.indexOf(event.target.value)
          if (index !== -1) {
            array.splice(index, 1);
           
            setValues(values => ({
              ...values,
              ['languages']: array
            }));
          }
        }
      }
    }
    //setChecked(event.target.checked);
  };

  return (
      <form
        {...rest}
        className={clsx(classes.root, className)}
        onSubmit={handleSubmit}
      >
        
        <div className={classes.content}>
          <Grid container xs={12} spacing={2}>
          {languages.map((lang,index) => (
            <> 
                        <Grid item xs={12}>
                        <TextareaAutosize
                        className={classes.descriptionfield}
                        rowsMin={4}
                        rowsMax={4}
                        aria-label="maximum height"
                        placeholder={`Answer ( ${lang.name} *)`}
                        value={values[`answer${lang.name}`]}
                        onChange={handleinputchange(`answer${lang.name}`)}
                        defaultValue=""
                      />
                        </Grid> </>
          ))}
         <Grid
         container
              item
              xs={12}
              alignItems={'left'}
            >
                <Grid
              item
              xs={12}
              alignItems={'left'}
            >
              <Typography variant="h6">Sort order</Typography>
              <TextField
                fullWidth
                type="number"
                value={values.sortorder != null ? values.sortorder : ''}
                onChange={handleinputchange('sortorder')}
                inputProps={{ min: 0 }}
              />
            </Grid>
                <Grid
              item
              xs={12}
              alignItems={'left'}
            >
              <Typography variant="h6">Allow user to give comment</Typography>
             
              <Switch
                checked={values.is_comment}
                color="secondary"
                edge="start"
                name="canHire"
                onChange={handleswitchchange('is_comment')}
              />
            </Grid>
            </Grid>
          </Grid>
         
        </div>
        <div className={classes.actions}>
        <Button
            
            color="primary"
            type="submit"
            variant="contained"
            onClick={() => props.onValuechange(values)}
          >
            Update
          </Button>
            </div>
       
      </form>
  );
};

Addanswers.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  open: PropTypes.bool.isRequired,
  masters: PropTypes.object
};

export default Addanswers;
